// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceCircleFilledSvg from "@ant-design/icons-svg/es/asn/BehanceCircleFilled";
import AntdIcon from '../components/AntdIcon';

var BehanceCircleFilled = function BehanceCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceCircleFilledSvg
  }));
};

BehanceCircleFilled.displayName = 'BehanceCircleFilled';
export default React.forwardRef(BehanceCircleFilled);